import { z } from 'zod';
import i18n from '../i18n';

export const ZSignature = z.object({
  email: z
    .string({
      required_error: i18n.t('common.validation.emailRequired'),
    })
    .email({ message: i18n.t('common.validation.emailInvalid') }),
  password: z
    .string({
      required_error: i18n.t('common.validation.passwordRequired'),
    })
    .min(1, i18n.t('common.validation.passwordRequired')),
  comment: z
    .string({
      required_error: i18n.t('common.validation.reasonRequired'),
    })
    .trim()
    .min(1, i18n.t('common.validation.reasonRequired')),
});
export type Signature = z.infer<typeof ZSignature>;
